import { useTranslation } from "react-i18next";
import { WithAuthorization } from "../../../context";
import { Page } from "../../../components/Page";
import { Card } from "../../../components/Card";
import { Center, Tab, TabList, TabPanel, TabPanels, Tabs, Tooltip } from "@chakra-ui/react";
import { useState } from "react";
import { TotalCompanyEmissionsTab } from "./components/TotalCompanyEmissionsTab";
import { QUARTERS } from "../../../utils";
import { ByDimensionTab } from "./components/ByDimensionTab";
import { ByYearTab } from "./components/ByYearTab";

function CompanyEmissionsDashboard() {
  const { t } = useTranslation("translation", {
    keyPrefix: "companyEmissionsDashboard"
  });

  const [tabIndex, setTabIndex] = useState(0);
  const [selectedYear, setSelectedYear] = useState((new Date().getFullYear() - 1).toString());
  const [selectedQuarter, setSelectedQuarter] = useState(QUARTERS.ALL);

  return <Page title={t("page.title")} subTitle={t("page.subTitle")}>
    <Card>
      <Tabs colorScheme="customScheme" index={tabIndex} onChange={setTabIndex} isLazy>
        <Center>
          <TabList borderBottom="none">
            <Tab _focus={{ boxShadow: "none" }}>{t("tabs.totalEmissions.title")}</Tab>
            <Tooltip label={t("tabs.byDimension.tooltip")}>
              <Tab _focus={{ boxShadow: "none" }}>{t("tabs.byDimension.title")}</Tab>
            </Tooltip>
            <Tooltip label={t("tabs.byYear.tooltip")}>
              <Tab _focus={{ boxShadow: "none" }}>{t("tabs.byYear.title")}</Tab>
            </Tooltip>
          </TabList>
        </Center>
        <TabPanels>
          <TabPanel padding="0">
            <TotalCompanyEmissionsTab
              selectedYear={selectedYear}
              setSelectedYear={setSelectedYear}
              selectedQuarter={selectedQuarter}
              setSelectedQuarter={setSelectedQuarter}
            />
          </TabPanel>
          <TabPanel padding="0">
            <ByDimensionTab
              selectedYear={selectedYear}
              setSelectedYear={setSelectedYear}
              selectedQuarter={selectedQuarter}
              setSelectedQuarter={setSelectedQuarter}
            />
          </TabPanel>
          <TabPanel padding="0">
            <ByYearTab />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Card>
  </Page>;
}

export default WithAuthorization(CompanyEmissionsDashboard);